(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Mask = exports.default = /*#__PURE__*/function () {
  function Mask(id, styles, click, attachTo) {
    var _this = this;
    _classCallCheck(this, Mask);
    this.data = {
      id: id,
      styles: styles,
      element: null,
      shown: false,
      onClick: click
    };
    this.attachTo = document.querySelector(attachTo);
    if (!this.attachTo) {
      this.attachTo = document.body;
    }
    this.add();
    jQuery(document.body).on('click', "#mask-".concat(this.data.id), function () {
      _this.click();
    });
  }
  return _createClass(Mask, [{
    key: "add",
    value: function add() {
      this.attachTo.insertAdjacentHTML('beforeend', "<div id=\"mask-".concat(this.data.id, "\"></div>"));
      this.data.element = document.getElementById("mask-".concat(this.data.id));
      this.data.element.style.position = 'fixed';
      this.data.element.style.top = 0;
      this.data.element.style.left = 0;
      this.data.element.style.right = 0;
      this.data.element.style.bottom = 0;
      this.data.element.style.display = 'none';
      this.data.element.style.opacity = '0';
      for (var _i = 0, _Object$keys = Object.keys(this.data.styles); _i < _Object$keys.length; _i++) {
        var style = _Object$keys[_i];
        this.data.element.style[style] = this.data.styles[style];
      }
    }
  }, {
    key: "show",
    value: function show(complete) {
      var _this2 = this;
      gsap.to(this.data.element, {
        opacity: 1,
        duration: 0.3,
        onStart: function onStart() {
          _this2.data.element.style.display = 'block';
        },
        onComplete: function onComplete() {
          _this2.data.shown = true;
          if (complete) complete();
        }
      });
    }
  }, {
    key: "hide",
    value: function hide(complete) {
      var _this3 = this;
      gsap.to(this.data.element, {
        opacity: 0,
        display: "none",
        duration: 0.3,
        onComplete: function onComplete() {
          _this3.data.shown = true;
          if (complete) complete();
        }
      });
    }
  }, {
    key: "click",
    value: function click() {
      if (this.data.shown && this.data.onClick) {
        this.data.onClick();
      }
    }
  }]);
}();

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.block = block;
exports.toggleBlock = toggleBlock;
exports.unblock = unblock;
var _helper = require("./helper");
/**
 * Masks and blocks element passed
 *
 * @param {HTML Element} element
 * @param {Object} settings
 */
function block(element, settings) {
  if (undefined === element) {
    // console.warn('block element undefined');
    return;
  }

  // if the element is blocked or blocking, return
  if (element.dataset.hpyBlock === 'blocked' || element.dataset.hpyBlock === 'blocking') {
    return;
  }

  // if no settings are defined then create an empty object
  if (undefined === settings) {
    settings = {};
  }

  // create the mask element
  var mask = document.createElement('div');
  var defaults = {
    color: '#FFFFFF',
    opacity: '0.8',
    cursor: '',
    zIndex: '',
    pointerEvents: '',
    HTML: ''
  };
  settings = (0, _helper.mergeObject)(settings, defaults);
  mask.style.backgroundColor = settings.color;
  mask.classList.add('hpyBlock');
  mask.innerHTML = settings.HTML;

  // only set the parent to relative positioning if tis' not absolute
  if (element.style.position != 'absolute') {
    element.style.position = 'relative';
  }
  if (window.getComputedStyle(element).getPropertyValue("z-index") === 'auto') {
    element.style.zIndex = '1';
  }

  // append the mask to the element being blocked
  element.appendChild(mask);
  element.dataset.hpyBlock = 'blocking'; // set a data attribute to show it's now blocked

  var computedStyle = window.getComputedStyle(mask); // get the initial style applied by the stylesheet
  var transitionDurationInMilliseconds = parseFloat(computedStyle.transitionDuration) * 1000;
  if (isNaN(transitionDurationInMilliseconds)) {
    return;
  }
  mask.dataset.blockTransition = transitionDurationInMilliseconds; // set the transition timing for the callback
  mask.style.opacity = settings.opacity; // animate in the mask using css transition
  mask.style.cursor = settings.cursor; // set custom cursor
  mask.style.zIndex = settings.zIndex; // set custom z-index

  element.style.pointerEvents = settings.pointerEvents; // Change pointer event for element

  // set a callback to update the element data to fire after the css animation is complete
  setTimeout(function () {
    element.dataset.hpyBlock = 'blocked';
  }, transitionDurationInMilliseconds);
}

/**
 * Unblocks a previously blocked element
 *
 * @param {HTML Element} element
 */
function unblock(element) {
  if (!element || ['blocking', 'blocked'].indexOf(element.dataset.hpyBlock) === -1) {
    // console.warn('Element not blocked');
    return;
  }
  var children = element.children;
  var mask;
  for (var i = 0; i < children.length; i += 1) {
    if (children[i].className === 'hpyBlock') {
      mask = children[i];
      break;
    }
  }
  mask.style.opacity = 0;
  element.dataset.hpyBlock = 'blocking';
  setTimeout(function () {
    element.dataset.hpyBlock = '';
    element.removeChild(mask);
    element.style.pointerEvents = '';
  }, mask.dataset.blockTransition);
}

/**
 * Toggles between blocked and unblocked depending on elements data state
 *
 * @param {HTML Element} element
 */
function toggleBlock(element) {
  var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (element.dataset.hpyBlock === 'blocked') {
    unblock(element);
  } else {
    block(element, settings);
  }
}

},{"./helper":3}],3:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._debounce = _debounce;
exports._throttle = _throttle;
exports.attachEventToBody = attachEventToBody;
exports.copyToClipboard = copyToClipboard;
exports.createElementFromString = createElementFromString;
exports.disableScroll = disableScroll;
exports.enableScroll = enableScroll;
exports.getScrollbarWidth = getScrollbarWidth;
exports.getViewportHeight = getViewportHeight;
exports.getViewportWidth = getViewportWidth;
exports.isFunction = isFunction;
exports.mergeObject = mergeObject;
exports.skipLinkFocus = skipLinkFocus;
exports.validateCommentSubmission = validateCommentSubmission;
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Calculate the scroll bar width of the browser
 */
function getScrollbarWidth() {
  var outer = document.createElement("div");
  outer.style.visibility = "hidden";
  outer.style.width = "100px";
  outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps

  document.body.appendChild(outer);
  var widthNoScroll = outer.offsetWidth;
  // force scrollbars
  outer.style.overflow = "scroll";

  // add innerdiv
  var inner = document.createElement("div");
  inner.style.width = "100%";
  outer.appendChild(inner);
  var widthWithScroll = inner.offsetWidth;

  // remove divs
  outer.parentNode.removeChild(outer);
  return widthNoScroll - widthWithScroll;
}

/**
 * Get the browsers current viewport width
 */
function getViewportWidth() {
  return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
}

/**
 * Get the browsers current viewport height
 */
function getViewportHeight() {
  return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
}

/**
 * Function to debounce a function if run in quick successtion. If the function is called again before the timer ends it will clear it's. Only until
 * after the delay has expired will the func(tion) passed be called
 *
 * @param {Function} func - the function to run after debouncing
 * @param {object} timer - object with the timers
 * @param {string} key - the timer key to use
 * @param {int} delay - the delay in ms
 */
function _debounce(fn, time) {
  var timeout;
  return function () {
    var _arguments = arguments,
      _this2 = this;
    var functionCall = function functionCall() {
      return fn.apply(_this2, _arguments);
    };
    clearTimeout(timeout);
    timeout = setTimeout(functionCall, time);
  };
}
function _throttle(callback, limit) {
  var wait = false; // Initially, we're not waiting
  return function () {
    // We return a throttled function
    if (!wait) {
      // If we're not waiting
      callback.call(); // Execute users function
      wait = true; // Prevent future invocations
      setTimeout(function () {
        // After a period of time
        wait = false; // And allow future invocations
      }, limit);
    }
  };
}

/**
 * Determine if passed variable is a function
 *
 * @param {*} func
 */
function isFunction(func) {
  return func && {}.toString.call(func) === '[object Function]';
}

/**
 * File skip-link-focus-fix.js.
 *
 * Helps with accessibility for keyboard only users.
 */
function skipLinkFocus() {
  var isWebkit = navigator.userAgent.toLowerCase().indexOf('webkit') > -1;
  var isOpera = navigator.userAgent.toLowerCase().indexOf('opera') > -1;
  var isIe = navigator.userAgent.toLowerCase().indexOf('msie') > -1;
  if ((isWebkit || isOpera || isIe) && document.getElementById && window.addEventListener) {
    window.addEventListener('hashchange', function () {
      var id = location.hash.substring(1),
        element;
      if (!/^[A-z0-9_-]+$/.test(id)) {
        return;
      }
      element = document.getElementById(id);
      if (element) {
        if (!/^(?:a|select|input|button|textarea)$/i.test(element.tagName)) {
          element.tabIndex = -1;
        }
        element.focus();
      }
    }, false);
  }
}
function mergeObject(obj, defaultObj) {
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      // Push each value from `obj` into `extended`
      defaultObj[prop] = obj[prop];
    }
  }
  return defaultObj;
}
function createElementFromString(string) {
  var element = new DOMParser().parseFromString(string, 'text/html');
  return element.body.childNodes[0];
}
function attachEventToBody(element, callbackFn) {
  var _this = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  document.getElementsByTagName('body')[0].addEventListener('click', function (event) {
    var _iterator = _createForOfIteratorHelper(document.querySelectorAll(element)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var el = _step.value;
        if (el.contains(event.target)) {
          callbackFn(el, _this);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  });
}
function disableScroll() {
  // Get the current page scroll position
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

  // if any scroll is attempted, set this to the previous value
  window.onscroll = function () {
    window.scrollTo(scrollLeft, scrollTop);
  };
}
function enableScroll() {
  window.onscroll = function () {};
}
function copyToClipboard() {
  $(document.body).on('click', '.copy-to-clipboard', /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      var that, overlay, text, original_pos;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            that = this;
            if (!(that.dataset.copying === 'true')) {
              _context.next = 4;
              break;
            }
            return _context.abrupt("return");
          case 4:
            that.dataset.copying = true;
            overlay = createElementFromString("<span style=\"\n\t\t\t\tpadding:10px;\n\t\t\t\tborder-radius:10px;\n\t\t\t\tposition:absolute;\n\t\t\t\tinset: 0px;\n\t\t\t\topacity:1;\n\t\t\t\tz-inder:10;\n\t\t\t\">\n\t\t\t\t<span style=\"\n\t\t\t\t\tpadding: 10px;\n\t\t\t\t\tborder: 2px dashed;\n\t\t\t\t\tborder-radius: 6px;\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\tletter-spacing: 0.05em;\n\t\t\t\t\theight: 100%;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\tfont-size: inherit;\n\t\t\t\t\"></span>\n\t\t\t</span>");
            _context.prev = 6;
            if (navigator.clipboard) {
              _context.next = 9;
              break;
            }
            throw 'failed';
          case 9:
            text = that.textContent.replace(/(\r\n|\n|\r|\t)/gm, "");
            _context.next = 12;
            return navigator.clipboard.writeText(text);
          case 12:
            overlay.style.background = '#77a464';
            overlay.children[0].style.borderColor = '#396826';
            overlay.children[0].style.color = '#396826';
            overlay.children[0].textContent = 'copied';
            _context.next = 24;
            break;
          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](6);
            overlay.style.background = '#a94442';
            overlay.children[0].style.borderColor = '#621f1d';
            overlay.children[0].style.color = '#621f1d';
            overlay.children[0].textContent = 'Failed to copy';
          case 24:
            _context.prev = 24;
            original_pos = that.style.position;
            that.style.position = 'relative';
            that.appendChild(overlay);
            setTimeout(function () {
              overlay.style.transition = 'opacity 0.3s';
              overlay.style.opacity = '0';
              setTimeout(function () {
                that.style.position = original_pos;
                overlay.remove();
                that.dataset.copying = false;
              }, 300);
            }, 2000);
            return _context.finish(24);
          case 30:
          case "end":
            return _context.stop();
        }
      }, _callee, this, [[6, 18, 24, 30]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
}
function validateCommentSubmission() {
  jQuery('#commentform').on('submit', function (e) {
    var errors = [];
    jQuery(this).find('[required]').each(function () {
      if (!jQuery(this).val()) {
        errors.push({
          element: jQuery(this),
          message: '<strong class="text-uppercase">' + jQuery(this).parents('p').find('label').get(0).childNodes[0].textContent + '</strong> is required'
        });
      } else if (this.type === 'email' && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(jQuery(this).val())) {
        errors.push({
          element: $(this),
          message: '<strong class="text-uppercase">' + jQuery(this).parents('p').find('label').get(0).childNodes[0].textContent + '</strong> is an invalid email address'
        });
      }
    });
    if (errors.length) {
      e.preventDefault();
      jQuery('#commentform-errors').show().find('ul').empty();
      errors.forEach(function (err) {
        jQuery('#commentform-errors ul').append("<li>".concat(err.message, "</li>"));
      });
      return;
    }
    jQuery('#commentform-errors').hide();
  });
}

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _block = require("../helper/block");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Block = exports.default = /*#__PURE__*/function () {
  function Block() {
    _classCallCheck(this, Block);
    this.currentRequests = 0;
    this.options = {
      add: {
        color: 'rgba( 255,255,255, 0.9)',
        opacity: '1',
        HTML: '<div class="hpy-add-to-cart-mask"><div></div></div>'
      },
      cart: {
        color: 'rgba( 255,255,255, 0.9)',
        opacity: '1',
        HTML: '<div class="hpy-updating-cart-mask"><div class="hpy-add-to-cart-mask"><div></div></div></div>'
      }
    };
  }
  return _createClass(Block, [{
    key: "blockProductRemoval",
    value: function blockProductRemoval(key) {
      (0, _block.block)(document.querySelector(".smc-row[data-key=\"".concat(key, "\"]")), this.options.add);
    }
  }, {
    key: "unblockProductRemoval",
    value: function unblockProductRemoval(key) {
      (0, _block.unblock)(document.querySelector(".smc-row[data-key=\"".concat(key, "\"]")));
    }
  }, {
    key: "blockQueue",
    value: function blockQueue(id) {
      var _this = this;
      this.currentRequests++;
      this.getElementsToBlock(id).forEach(function (ele) {
        if (ele) (0, _block.block)(ele, _this.options.add);
      });
      this.blockCommonElements();
      this.blockMiniCart();
    }
  }, {
    key: "unblockQueue",
    value: function unblockQueue(id) {
      this.currentRequests--;
      this.getElementsToBlock(id).forEach(function (ele) {
        if (ele) (0, _block.unblock)(ele);
      });
      if (this.currentRequests === 0) {
        this.unblockCommonElements();
        this.unblockMiniCart();
      }
    }
  }, {
    key: "getCommonElements",
    value: function getCommonElements() {
      var elements = [document.querySelector('.smc-checkout')].concat(_toConsumableArray(document.querySelectorAll('.smc-continue')), [document.getElementById('smc')]);
      return elements.filter(function (ele) {
        return !!ele;
      });
    }
  }, {
    key: "blockCommonElements",
    value: function blockCommonElements() {
      var _this2 = this;
      var _iterator = _createForOfIteratorHelper(document.querySelectorAll('.smc')),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var toggle = _step.value;
          toggle.classList.add('refreshing');
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.getCommonElements().forEach(function (element) {
        if (element) {
          (0, _block.block)(element, _this2.options.add);
        }
      });
    }
  }, {
    key: "unblockCommonElements",
    value: function unblockCommonElements() {
      var _this3 = this;
      var _iterator2 = _createForOfIteratorHelper(document.querySelectorAll('.smc')),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var toggle = _step2.value;
          toggle.classList.remove('refreshing');
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this.getCommonElements().forEach(function (element) {
        if (element) {
          (0, _block.unblock)(element, _this3.options.add);
        }
      });
    }
  }, {
    key: "getElementsToBlock",
    value: function getElementsToBlock() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var button = document.querySelector(".hpy-add-to-cart[data-id=\"".concat(id, "\"]"));
      if (!button) {
        button = document.querySelector(".hpy-add-to-cart");
      }
      var elements = [button];
      return elements.filter(function (ele) {
        return !!ele;
      });
    }
  }, {
    key: "blockMiniCart",
    value: function blockMiniCart() {
      (0, _block.block)(document.querySelector('.smc-cart-wrap'), this.options.cart);
    }
  }, {
    key: "unblockMiniCart",
    value: function unblockMiniCart() {
      (0, _block.unblock)(document.querySelector('.smc-cart-wrap'));
    }
  }, {
    key: "getCart",
    value: function getCart() {
      return [document.querySelector('.woocommerce-cart-form'), document.querySelector('.cart_totals')];
    }
  }, {
    key: "blockCart",
    value: function blockCart() {
      this.getCart().forEach(function (ele) {
        if (ele) (0, _block.block)(ele);
      });
    }
  }, {
    key: "unblockCart",
    value: function unblockCart() {
      this.getCart().forEach(function (ele) {
        if (ele) (0, _block.unblock)(ele);
      });
    }
  }]);
}();

},{"../helper/block":2}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Cart = exports.default = /*#__PURE__*/function () {
  function Cart(urls) {
    var _this = this;
    var light = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    _classCallCheck(this, Cart);
    this.isQuickShop = document.body.classList.contains('page-template-template-quick_shop');
    this.data = {
      contents: [],
      total: 0,
      count: 0
    };
    this.urls = urls;
    if (!light) {
      this.data.symbol = document.getElementById('smc-wrap').dataset.symbol;
      this.generate();
      jQuery(document.body).on('wc_fragments_refreshed wc_fragments_loaded', function () {
        return _this.generate();
      });
    }
  }
  return _createClass(Cart, [{
    key: "add",
    value: function add(_ref) {
      var _this2 = this;
      var id = _ref.id,
        qty = _ref.qty,
        variant = _ref.variant,
        variations = _ref.variations,
        nonce = _ref.nonce,
        attributes = _ref.attributes;
      return new Promise(function (resolve, reject) {
        jQuery.ajax({
          url: _this2.urls.rest.add,
          method: 'POST',
          dataType: 'json',
          data: _objectSpread({
            id: id,
            quantity: qty,
            variant: variant,
            variations: variations
          }, attributes),
          beforeSend: function beforeSend(xhr) {
            xhr.setRequestHeader('X-WP-Nonce', nonce);
          },
          error: function error(jqXHR, textStatus, errorThrown) {
            reject([jqXHR, textStatus, errorThrown]);
          },
          success: function success(response) {
            if (response.success) {
              resolve(response.data);
            } else {
              reject(response.data);
            }
          }
        });
      });
    }
  }, {
    key: "remove",
    value: function remove(_ref2) {
      var _this3 = this;
      var key = _ref2.key,
        nonce = _ref2.nonce;
      return new Promise(function (resolve, reject) {
        if (!key) {
          reject('No Key');
        }
        jQuery.ajax({
          url: _this3.urls.rest.remove,
          method: 'POST',
          dataType: 'json',
          data: {
            key: key
          },
          beforeSend: function beforeSend(xhr) {
            xhr.setRequestHeader('X-WP-Nonce', nonce);
          },
          error: function error(jqXHR, textStatus, errorThrown) {
            reject([jqXHR, textStatus, errorThrown]);
          },
          success: function success(response) {
            if (response.success) {
              resolve(response.data);
            } else {
              reject(response.error);
            }
          }
        });
      });
    }
  }, {
    key: "getContents",
    value: function getContents() {
      return this.data.contents;
    }
  }, {
    key: "getTotal",
    value: function getTotal() {
      return this.data.total;
    }
  }, {
    key: "getCount",
    value: function getCount() {
      return this.data.count;
    }
  }, {
    key: "getSymbol",
    value: function getSymbol() {
      return this.data.symbol;
    }
  }, {
    key: "update",
    value: function update(totals) {
      this.data.count = totals.count;
      this.data.total = totals.total;
    }
  }, {
    key: "addProduct",
    value: function addProduct(product) {
      if (!this.data.contents.length) {
        this.data.contents.push(product);
        return;
      }
      var item = this.data.contents.find(function (i) {
        return i.key === product.key;
      });
      if (item) {
        item.qty = product.qty;
        item.price = product.price;
      } else {
        this.data.contents.push(product);
      }
    }
  }, {
    key: "removeProduct",
    value: function removeProduct(product) {
      if (!this.data.contents.length) {
        return;
      }
      var index = this.data.contents.findIndex(function (i) {
        return i.key === product.key;
      });
      this.data.contents.splice(index, 1);
    }
  }, {
    key: "generate",
    value: function generate() {
      var fragments = JSON.parse(sessionStorage.getItem(wc_cart_fragments_params.fragment_name));
      if (!fragments || !fragments.smc_cart_contents) {
        this.generateCartFromDom();
      } else {
        this.data.contents = fragments.smc_cart_contents.contents;
        this.data.total = parseFloat(fragments.smc_cart_contents.total);
        this.data.count = parseInt(fragments.smc_cart_contents.count);
      }
    }
  }, {
    key: "generateCartFromDom",
    value: function generateCartFromDom() {
      var total = document.getElementById('#smc-row-total');
      if (total) {
        this.datat.total = parseFloat(total.dataset.total);
        this.data.count = parseInt(total.dataset.qty);
      }
      var cart = document.querySelectorAll('#smc-cart .smc-cart-items .smc-row');
      if (cart) {
        var _iterator = _createForOfIteratorHelper(cart),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var row = _step.value;
            var product = {
              key: row.dataset.key,
              id: row.dataset.id,
              name: row.dataset.name,
              qty: parseInt(row.dataset.qty),
              price: parseFloat(row.dataset.price)
            };
            this.data.contents.push(product);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }]);
}();

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _helper = require("../helper/helper");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AjaxQueue = exports.default = /*#__PURE__*/function () {
  /**
   * 
   * @param {object} options 
   * options.add - called when an item is added tot he queue
   * options.run - called when the queue is first run
   * options.before - called before each item in queue is processed
   * options.method - called for each item in the queue
   * options.step - called after each item is processed
   * options.complete - called after queue is complete
   * options.error - called when an error is caught on each item
   * 
   */
  function AjaxQueue(options) {
    _classCallCheck(this, AjaxQueue);
    if (!options || !options.method) {
      console.warn('No options provided for queue');
      return;
    }
    this.queue = [];
    this.callback = false;
    this.state = {
      running: false,
      resultsCache: []
    };
    this.results = {
      complete: [],
      failed: []
    };
    this.options = options;
  }

  // add an item to the queue and kick it off
  return _createClass(AjaxQueue, [{
    key: "add",
    value: function add(data) {
      this.queue.push(data);
      this.call('add', data);
      this.run();
    }

    // start the queue
  }, {
    key: "run",
    value: function () {
      var _run = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.state.running) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              this.state.running = true;
              _context.prev = 3;
              this.call('run');
              _context.next = 7;
              return this.processItem();
            case 7:
              _context.next = 12;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](3);
              console.error(_context.t0);
            case 12:
              _context.prev = 12;
              this.state.running = false;
              this.call('complete', this.results);
              this.clearResults();
              return _context.finish(12);
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[3, 9, 12, 17]]);
      }));
      function run() {
        return _run.apply(this, arguments);
      }
      return run;
    }() // process all items in the queue.
    // the promise is never rejected so the queue doesn't short circuit and it will run all items. If an item fails it will be logged and the queue will continue on
  }, {
    key: "processItem",
    value: function processItem() {
      return new Promise(( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(resolve, reject) {
          var item, params;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                item = this.queue.shift(); // get the first key in the queue
                _context2.prev = 1;
                if (item) {
                  _context2.next = 4;
                  break;
                }
                throw 'Item not found';
              case 4:
                this.call('before', item);
                _context2.next = 7;
                return this.options.method(item);
              case 7:
                params = _context2.sent;
                this.results.complete.push(params);
                this.call('step', {
                  params: params,
                  item: item
                });
                _context2.next = 17;
                break;
              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](1);
                console.error(_context2.t0);
                this.results.failed.push({
                  item: item,
                  error: _context2.t0
                });
                this.call('error', {
                  item: item,
                  error: _context2.t0
                });
              case 17:
                _context2.prev = 17;
                if (!this.queue.length) {
                  _context2.next = 21;
                  break;
                }
                _context2.next = 21;
                return this.processItem();
              case 21:
                resolve();
                return _context2.finish(17);
              case 23:
              case "end":
                return _context2.stop();
            }
          }, _callee2, this, [[1, 12, 17, 23]]);
        }));
        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }()).bind(this));
    }

    // wrapper for calling callback functions
  }, {
    key: "call",
    value: function call(method, parameters) {
      if (this.options[method] && (0, _helper.isFunction)(this.options[method])) {
        this.options[method](parameters);
      }
    }

    // clearing the results and adding the previous results to the cache with a timestamp
  }, {
    key: "clearResults",
    value: function clearResults() {
      this.results.timestamp = Date.now();
      this.state.resultsCache.push(this.results);
      this.results = {
        complete: [],
        failed: []
      };
    }
  }]);
}();

},{"../helper/helper":3}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _helper = require("../helper/helper");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Notices = exports.default = /*#__PURE__*/function () {
  function Notices() {
    var _this = this;
    _classCallCheck(this, Notices);
    this.wrap = false;
    this.notices = [];
    this.limit = 4;
    this.timeout = 5000;
    this.createNoticesBlock();
    window.addEventListener('resize', this.calculatePosition.bind(this), {
      passive: true
    });
    document.addEventListener('scroll', this.calculatePosition.bind(this), {
      passive: true
    });
    jQuery(document.body).on('click', '.hpy--notice', function (e) {
      if ('A' === e.target.tagName) {
        if (e.target.classList.contains('button')) {
          e.preventDefault();
          jQuery(document.body).trigger('hpy_open_mini_cart');
        }
        return;
      }
      var notice = _this.notices.find(function (notice) {
        return notice.id == e.currentTarget.dataset.id;
      });
      if (notice) {
        _this.removeNotice(notice);
      }
    });
  }
  return _createClass(Notices, [{
    key: "createNoticesBlock",
    value: function createNoticesBlock() {
      this.wrap = document.createElement('div');
      this.wrap.id = 'hpy--notices';
      this.wrap.style.position = 'fixed';
      this.wrap.style.minWidth = '20px';
      this.wrap.style.background = 'transparent';
      this.wrap.style.zIndex = 98;
      this.wrap.style.maxWidth = '500px';
      this.wrap.style.width = '100%';
      this.wrap.style.paddingLeft = '10px';
      this.wrap.style.right = 0;
      this.calculatePosition();
      document.body.appendChild(this.wrap);
    }
  }, {
    key: "calculatePosition",
    value: function calculatePosition() {
      var header = document.getElementById('masthead');
      var breadcrumbs = document.querySelector('.hpy-breadcrumbs-wrap');
      var rect = header.getBoundingClientRect();
      if (breadcrumbs) {
        rect = breadcrumbs.getBoundingClientRect();
      }
      var offset = rect.bottom;
      if (offset < 0) {
        offset = 0;
      }
      this.wrap.style.top = "calc( ".concat(offset, "px + 1rem )");
      this.wrap.style.maxHeight = "".concat((0, _helper.getViewportHeight)() - offset, "px");
    }
  }, {
    key: "add",
    value: function add(data) {
      var _this2 = this;
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'success';
      this.calculatePosition();
      if (data.notices && this.wrap) {
        data.notices.forEach(function (notice) {
          if (_this2.notices.length >= _this2.limit) {
            _this2.removeNotice(_this2.notices[0]);
          }
          _this2.addNotice(notice.notice, type);
        });
      }
    }
  }, {
    key: "clearWCNotices",
    value: function clearWCNotices() {
      var notice = document.querySelector('.notices .woocommerce-message');
      if (notice) {
        notice.parentElement.removeChild(notice);
      }
    }
  }, {
    key: "removeNotice",
    value: function removeNotice(notice) {
      var _this3 = this;
      clearTimeout(notice.timeout);
      var noticeElement = document.querySelector(".hpy--notice[data-id=\"".concat(notice.id, "\"]"));
      if (noticeElement) {
        noticeElement.style.transform = 'translateX(110%)';
        gsap.to(noticeElement, {
          x: '100%',
          onComplete: function onComplete() {
            _this3.wrap.removeChild(noticeElement.parentElement);
            _this3.notices = _this3.notices.filter(function (n) {
              return n.id !== notice.id;
            });
            _this3.calculatePosition();
          }
        });
      }
      this.calculatePosition();
    }
  }, {
    key: "addNotice",
    value: function addNotice(notice, type) {
      var _this4 = this;
      var newNotice = {
        id: this.getUID(),
        text: notice
      };
      this.notices.push(newNotice);
      this.wrap.insertAdjacentHTML('beforeend', this.createNotice(newNotice, type));
      var noticeElement = this.wrap.querySelector(".hpy--notice[data-id=\"".concat(newNotice.id, "\"]"));
      gsap.from(noticeElement, {
        x: '100%',
        onComplete: function onComplete() {
          _this4.calculatePosition();
          newNotice.timeout = setTimeout(function () {
            _this4.removeNotice(newNotice);
          }, _this4.timeout);
        }
      });
    }
  }, {
    key: "getUID",
    value: function getUID() {
      return Date.now();
    }
  }, {
    key: "createNotice",
    value: function createNotice(notice, type) {
      return "<div class=\"justify-end d-flex\"><div class=\"hpy--notice hpy--notice_".concat(type, " d-inline-flex align-center\" data-id=\"").concat(notice.id, "\">").concat(notice.text, "</div></div>");
    }
  }]);
}();

},{"../helper/helper":3}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _helper = require("./helper/helper");
var _mask = _interopRequireDefault(require("./components/mask"));
var _Cart = _interopRequireDefault(require("./mini-cart/Cart"));
var _ajaxQueue = _interopRequireDefault(require("./mini-cart/ajaxQueue"));
var _Block = _interopRequireDefault(require("./mini-cart/Block"));
var _notices = _interopRequireDefault(require("./mini-cart/notices"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var MiniCart = exports.default = /*#__PURE__*/function () {
  function MiniCart() {
    _classCallCheck(this, MiniCart);
    this.scrollbarWidth = (0, _helper.getScrollbarWidth)();
    this.block = new _Block.default();
    this.state = {
      open: false,
      mask: new _mask.default('mini-cart', {
        backgroundColor: hpyMCApi.backgroundColor
      }, this.close.bind(this)),
      currentRequests: 0,
      cartPage: document.body.classList.contains('woocommerce-cart'),
      checkoutPage: document.body.classList.contains('woocommerce-checkout'),
      sizeInit: false,
      runningRemove: false,
      runningAdd: false,
      shouldRefreshCart: false
    };
    this.cart = new _Cart.default(hpyMCApi);
    this.removeQueue = new _ajaxQueue.default({
      method: this.cart.remove.bind(this.cart),
      add: this.onRemoveAdd.bind(this),
      run: this.onRemoveRun.bind(this),
      step: this.onRemoveStep.bind(this),
      complete: this.onRemoveComplete.bind(this),
      error: this.onRemoveError.bind(this)
    });
    this.addQueue = new _ajaxQueue.default({
      method: this.cart.add.bind(this.cart),
      add: this.onAdd.bind(this),
      // run: this.onAddRun.bind(this),
      step: this.onAddStep.bind(this),
      complete: this.onAddComplete.bind(this),
      error: this.onAddError.bind(this)
    });
    this.removing = [];
    this.adding = [];
    this.notices = new _notices.default();
    this.sizeMiniCart();
    this.events();
  }
  return _createClass(MiniCart, [{
    key: "events",
    value: function events() {
      var _this = this;
      jQuery(document.body).on('hpy_open_mini_cart', function (e) {
        return _this.open(e);
      }).on('wc_fragments_refreshed wc_fragments_loaded', function () {
        return _this.cartFragmentsRefreshed();
      }).on('click', '#smc', function (e) {
        return _this.open(e);
      }).on('click', '.smc-checkout', function () {
        return jQuery(document).trigger("wpmBeginCheckout");
      }).on('click', '#smc-header .smc-close', function () {
        return _this.close();
      }).on('click', '.smc-remove', function (e) {
        return _this.removeFromCart(e);
      }).on('click', '.hpy-add-to-cart', this.addToCart.bind(this));
      jQuery(window).on('load DOMContentLoaded', this.sizeMiniCart.bind(this));
      window.addEventListener('resize', (0, _helper._debounce)(this.sizeMiniCart.bind(this), 100), {
        passive: true
      });
    }

    // add a product to the cart
  }, {
    key: "addToCart",
    value: function () {
      var _addToCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
        var elements;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              if (!e.currentTarget.classList.contains('disabled')) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              _context.prev = 3;
              elements = this.getAddtoCart(e.currentTarget);
              if (!(!elements || !elements.product || !elements.product.id)) {
                _context.next = 7;
                break;
              }
              return _context.abrupt("return");
            case 7:
              elements.product.event = e;
              this.state.runningAdd = true;
              this.addQueue.add(elements.product);
              _context.next = 15;
              break;
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](3);
              console.error(_context.t0);
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[3, 12]]);
      }));
      function addToCart(_x) {
        return _addToCart.apply(this, arguments);
      }
      return addToCart;
    }() // remove a product from the cart
  }, {
    key: "removeFromCart",
    value: function removeFromCart(e) {
      var row = e.target.parentElement;
      if (row.dataset.key) {
        this.state.runningRemove = true;
        this.removeQueue.add({
          key: row.dataset.key,
          nonce: document.getElementById('smc-remove-nonce').value
        });
      }
    }
  }, {
    key: "getAddtoCartSingleProduct",
    value: function getAddtoCartSingleProduct(target, elements) {
      var qty = elements.row.find('input[name="quantity"]').val();
      if (!Number(qty) && qty > 0) {
        console.warn('Invalid quantity: ', target, qty);
        return false;
      }
      elements.product.qty = qty;
      elements.product.name = elements.row.find('.product_title').data('product_title');
      if (!elements.product.attributes) {
        elements.product.attributes = {};
      }
      if (elements.row.hasClass('product-type-variable')) {
        elements.product.id = elements.row.find('input[name="product_id"]').val();
        elements.product.variant = elements.row.find('input[name="variation_id"].variation_id').val();
        var selects = elements.row.find('.product--variation_attribute select');
        elements.product.variations = {};
        elements.product.name += ' -';
        selects.each(function (i, select) {
          select = jQuery(select);
          elements.product.variations[select.attr('name')] = select.val();
          elements.product.name += " ".concat(select.find('option:selected').text());
        });
        if (elements.product.variant == 0) {
          throw new Error('Invalid product, please try again');
        }
      } else {
        elements.product.id = target.val();
      }
      var form = target.closest('form.cart');

      // serialize form field
      var formFields = form.serializeArray();
      for (var field in formFields) {
        if (elements.product[formFields[field]['name']] || 'add-to-cart' === formFields[field]['name']) {
          continue;
        }

        // remove field that are hidden
        var element = document.getElementsByName(formFields[field]['name']);
        if (element.length) {
          element = _toConsumableArray(element).filter(function (el) {
            return el.parentElement.offsetParent !== null;
          });
        }
        if (!element.length) {
          continue;
        }

        // include rest nonce as separate field
        if ('wp_rest_nonce' === formFields[field]['name']) {
          elements.product.nonce = formFields[field]['value'];
        } else {
          elements.product.attributes[formFields[field]['name']] = formFields[field]['value'];
        }
      }
      return elements;
    }
  }, {
    key: "getAddtoCart",
    value: function getAddtoCart(target) {
      target = jQuery(target);
      if (target.hasClass('refresh-cart')) {
        this.shouldRefreshCart = true;
      }
      var tooltip = target.data('type') === 'tooltip';
      var row = target.closest(tooltip ? '.tooltip-content' : '.product');
      var elements = {
        row: row,
        product: {
          id: 0,
          qty: 0,
          name: '',
          variant: 0,
          variations: {},
          attributes: {}
        }
      };
      if (!elements.row) {
        console.warn('Row not found for target: ', target);
        return false;
      }
      var nonce = row.find('input[name^="_wpnonce"]').val();
      if (nonce) {
        elements.product.attributes['_wpnonce'] = nonce;
      }
      if (target.hasClass('single_add_to_cart_button')) {
        return this.getAddtoCartSingleProduct(target, elements);
      }
      elements.product.id = target.data('product_id');
      elements.product.qty = target.data('qty');
      elements.product.name = target.data('name');
      if (elements.row.hasClass('nyp-product') && elements.row.hasClass('product-type-simple')) {
        if (!elements.product.attributes) {
          elements.product.attributes = {};
        }
        var val = row.find('input[name="nyp"]').val();
        if (!val || '' === val.trim()) {
          alert('Please enter a value');
          return false;
        } else if (isNaN(parseFloat(val))) {
          alert('Please enter a numeric value');
          return false;
        }
        elements.product.attributes['nyp'] = val;
        elements.product.attributes['update-price'] = row.find('input[name="update-price"]').val();
        elements.product.attributes['_nypnonce'] = row.find('input[name="_nypnonce"]').val();
      }
      if (elements.row.hasClass('product-type-variable')) {
        var select = elements.row.find('select.pnz--product_variation');
        elements.product.variant = select.val();
        if (!elements.product.variant) {
          alert('Please select a variant');
          return false;
        }
        var option = select.find("option[value=\"".concat(elements.product.variant, "\"]"));
        elements.product.variations = option.data('variations');
        elements.product.name += " - ".concat(option.data('name'));
      }
      return elements;
    }

    // add a product to the mini cart list and update all totals
  }, {
    key: "addToMenu",
    value: function addToMenu(data, product) {
      // if nothing exists in the internal cart then clear the contents
      if (!this.cart.getContents().length) {
        var wrap = this.getItemsWrap();
        wrap.innerHTML = '';
      }

      // setup product object
      var productData = {
        key: data.item.key,
        id: product.id,
        name: product.name,
        qty: parseInt(data.item.qty),
        price: parseFloat(data.item.total)
      };
      this.updateMiniCart(data.fragments.fragments);
      this.cart.update(data.cart); //  update the internal cart state totals
      this.cart.addProduct(productData); //  update the internal cart state contents

      if (!this.state.sizeInit) {
        this.sizeMiniCart();
      }
    }
  }, {
    key: "updateMiniCart",
    value: function updateMiniCart(fragments) {
      for (var fragment in fragments) {
        var element = document.querySelector(fragment);
        if (element) {
          var replacement = (0, _helper.createElementFromString)(fragments[fragment]);
          // default replaced cart element to be open if already open
          if ('#smc-wrap' === fragment && this.state.open) {
            replacement.style.transform = 'translateX(0)';
            replacement.setAttribute('aria-expanded', true);
          }
          element.replaceWith(replacement);
        }
      }
    }

    // functions to trigger when cart fragments have been refreshed
  }, {
    key: "cartFragmentsRefreshed",
    value: function cartFragmentsRefreshed() {
      this.sizeMiniCart();
      // set the new cart display to open state if already open when updating fragments

      if (this.state.open) {
        var cart = this.getCartWrap();
        cart.style.transform = 'translateX(0)';
        cart.setAttribute('aria-expanded', true);
      }
      if (this.state.runningAdd || this.state.runningRemove) {
        this.block.blockCommonElements();
        this.block.blockMiniCart();
      }
    }

    // add sizing to the product wrap to hide the scrollbar and setup the overflow height
  }, {
    key: "sizeMiniCart",
    value: function sizeMiniCart() {
      var wrap = document.querySelector('.smc-cart-wrap');
      if (wrap) {
        wrap.style.maxHeight = this.getMaxHeight();
        wrap.style.width = "calc( 100% + ".concat(this.scrollbarWidth, "px )");
      }
    }

    // calculate the maximum height of the product wrap to allow overflow scrolling
  }, {
    key: "getMaxHeight",
    value: function getMaxHeight() {
      var total = document.querySelector('.smc-cart-total');
      if (total) {
        this.state.sizeInit = true;
        var maxHeight = document.getElementById('smc-header').offsetHeight + this.getFooterHeight() + total.offsetHeight;
        var viewport = (0, _helper.getViewportHeight)();
        if (document.body.classList.contains('admin-bar')) {
          var adminBar = document.getElementById('wpadminbar');
          if (adminBar) {
            viewport -= adminBar.offsetHeight;
          }
        }
        return "".concat(viewport - maxHeight, "px");
      }
      return '';
    }
  }, {
    key: "getFooterHeight",
    value: function getFooterHeight() {
      var footer = document.getElementById('smc-footer');
      return footer ? footer.offsetHeight : 0;
    }

    // open the mini cart
  }, {
    key: "open",
    value: function open(e) {
      var _this2 = this;
      if (!this.state.checkoutPage) {
        e.preventDefault();
        if (!this.state.open && !this.state.cartPage) {
          var cart = this.getCartWrap();
          gsap.to(cart, {
            x: 0
          });
          this.setDocumentOverflow(true);
          this.state.mask.show(function () {
            cart.setAttribute('aria-expanded', true);
            _this2.state.open = true;
          });
        }
      }
    }

    // close the mini cart
  }, {
    key: "close",
    value: function close() {
      var _this3 = this;
      if (this.state.open && !this.state.runningRemove) {
        var cart = this.getCartWrap();
        gsap.to(cart, {
          x: '105%'
        });
        this.state.mask.hide(function () {
          cart.setAttribute('aria-expanded', false);
          _this3.state.open = false;
          _this3.setDocumentOverflow();
        });
      }
    }
  }, {
    key: "setDocumentOverflow",
    value: function setDocumentOverflow(disable) {
      if (disable) {
        document.documentElement.style.overflow = 'hidden';
        document.documentElement.style.height = '100%';
        document.body.style.paddingRight = "".concat(this.scrollbarWidth, "px");
      } else {
        document.documentElement.style.overflow = '';
        document.documentElement.style.height = '%';
        document.body.style.paddingRight = '';
      }
    }

    // get the minicart wrap from the toggles control
  }, {
    key: "getCartWrap",
    value: function getCartWrap() {
      var controls = document.getElementById('smc').getAttribute('aria-controls');
      return document.getElementById(controls);
    }
  }, {
    key: "getMiniCart",
    value: function getMiniCart() {
      return document.getElementById('smc-cart');
    }
  }, {
    key: "getItemsWrap",
    value: function getItemsWrap() {
      return document.querySelector('#smc-cart .smc-cart-items');
    }

    /**
     * Add product to cart callback functions
     */
  }, {
    key: "onAdd",
    value: function onAdd(_ref) {
      var id = _ref.id;
      this.adding.push(id);
      this.block.blockQueue(id);
      if (this.shouldRefreshCart) {
        this.block.blockCart();
      }
    }
  }, {
    key: "onAddStep",
    value: function onAddStep(_ref2) {
      var _this4 = this;
      var params = _ref2.params,
        item = _ref2.item;
      this.block.unblockQueue(item.id);
      this.addToMenu(params, item); // after adding add to the menu and update all internal totals

      this.notices.clearWCNotices(); // clear any added to cart notices to prevent confusion about what's been added
      this.notices.add(params, 'success');
      this.removeFromAdding(item.id);

      // reblock all elements after fragment refresh
      if (this.adding.length) {
        this.adding.forEach(function (id) {
          _this4.block.blockQueue(id);
          _this4.block.blockCart();
        });
      }
      var button = jQuery(".hpy-add-to-cart[data-product_id=\"".concat(item.id, "\"]"));
      jQuery(document.body).trigger('hpy_add_to_cart', [item.event]);
      jQuery(document.body).trigger('added_to_cart', [params.fragments.fragments, params.fragments.cart_hash, button]);
      this.sizeMiniCart();
    }
  }, {
    key: "onAddComplete",
    value: function onAddComplete() {
      this.state.runningAdd = false;
      this.refreshCart();
      jQuery(document.body).trigger('hpy_add_to_cart_complete');
    }
  }, {
    key: "refreshCart",
    value: function refreshCart() {
      if (this.shouldRefreshCart) {
        this.block.unblockCart();
        this.shouldRefreshCart = false;
        jQuery(document).trigger('wc_update_cart');
      }
    }
  }, {
    key: "onAddError",
    value: function onAddError(_ref3) {
      var item = _ref3.item,
        error = _ref3.error;
      this.removeFromAdding(item.id);
      this.notices.add(error, 'error');
      this.block.unblockQueue(item.id);
    }
  }, {
    key: "removeFromAdding",
    value: function removeFromAdding(id) {
      var index = this.adding.indexOf(id);
      if (index !== -1) {
        this.adding.splice(index, 1);
      }
    }

    /**
     * Remove product from cart callback functions
     */
  }, {
    key: "onRemoveAdd",
    value: function onRemoveAdd(_ref4) {
      var key = _ref4.key;
      this.removing.push(key);
      this.block.blockProductRemoval(key);
    }
  }, {
    key: "onRemoveRun",
    value: function onRemoveRun() {
      this.block.blockCommonElements();
    }
  }, {
    key: "onRemoveStep",
    value: function onRemoveStep(_ref5) {
      var _this5 = this;
      var params = _ref5.params;
      this.updateMiniCart(params.fragments.fragments);
      this.cart.update(params.cart); //  update the internal cart state
      this.cart.removeProduct(params.key);
      this.removeFromRemoving(params.key);

      // reblock all elements after fragment refresh
      if (this.removing.length) {
        this.removing.forEach(function (item) {
          _this5.block.blockProductRemoval(item);
          _this5.block.blockCommonElements();
        });
      }
      if (params.cart.count === 0) {
        this.state.sizeInit = false;
      }
      this.sizeMiniCart();
    }
  }, {
    key: "onRemoveComplete",
    value: function onRemoveComplete(results) {
      this.state.runningRemove = false;
      this.block.unblockCommonElements();
      jQuery(document.body).trigger('hpy_remove_cart_item');
      var last = results.complete[results.complete.length - 1];
      jQuery(document.last).trigger('removed_from_cart', [last.fragments.fragments, last.fragments.cart_hash]);
    }
  }, {
    key: "onRemoveError",
    value: function onRemoveError(params) {
      this.removeFromRemoving(params.item.key);
      this.block.unblockProductRemoval(params.item.key);
    }
  }, {
    key: "removeFromRemoving",
    value: function removeFromRemoving(id) {
      var index = this.removing.indexOf(id);
      if (index !== -1) {
        this.removing.splice(index, 1);
      }
    }
  }]);
}();
new MiniCart();

},{"./components/mask":1,"./helper/helper":3,"./mini-cart/Block":4,"./mini-cart/Cart":5,"./mini-cart/ajaxQueue":6,"./mini-cart/notices":7,"regenerator-runtime/runtime":9}],9:[function(require,module,exports){
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; };
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) });

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: true });
  defineProperty(
    GeneratorFunctionPrototype,
    "constructor",
    { value: GeneratorFunction, configurable: true }
  );
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    defineProperty(this, "_invoke", { value: enqueue });
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per GeneratorResume behavior specified since ES2015:
        // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
        // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method;
    var method = delegate.iterator[methodName];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method, or a missing .next method, always terminate the
      // yield* loop.
      context.delegate = null;

      // Note: ["return"] must be used for ES3 parsing compatibility.
      if (methodName === "throw" && delegate.iterator["return"]) {
        // If the delegate iterator has a return method, give it a
        // chance to clean up.
        context.method = "return";
        context.arg = undefined;
        maybeInvokeDelegate(delegate, context);

        if (context.method === "throw") {
          // If maybeInvokeDelegate(context) changed context.method from
          // "return" to "throw", let that override the TypeError below.
          return ContinueSentinel;
        }
      }
      if (methodName !== "return") {
        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a '" + methodName + "' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(val) {
    var object = Object(val);
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable != null) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    throw new TypeError(typeof iterable + " is not iterable");
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  typeof module === "object" ? module.exports : {}
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}

},{}]},{},[8]);
